import { AutoFormattedCurrency } from "./formatted-currency";
import ButtonLink from "./button-link";
import ButtonMenu from "./button-menu";
import classes from "../classes";
import CurrencySelector from "./currency-selector";
import { Link } from "react-router-dom";
import NotificationButton from "./notification-button";
import pure from "./higher-order/pure";
import React from "react";
import sequence from "../sequence";

/* states:
 *
 * enter-now
 * confirm
 * tournament.get("entering")
 * confirmed
 */
export default class BuyBox extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      currency: Object.keys(props.price).sort().reverse()[0],
      quantity: 1,
      state: "enter-now"
    };
    this.onCurrencyChange = this.onCurrencyChange.bind(this);
    this.onQuantityChange = this.onQuantityChange.bind(this);
    this.onStateChange = this.onStateChange.bind(this);
  }

  static getDerivedStateFromProps(props) {
    if (props.disabled) {
      return {
        state: "enter-now"
      };
    }
    return null;
  }

  componentWillUnmount() {
    var { currency, quantity, state } = this.state;
    var { onRemoveFromCart } = this.props;

    if (state === "confirm" && onRemoveFromCart) {
      onRemoveFromCart(quantity, currency);
    }
  }

  onCurrencyChange(currency) {
    this.setState({ currency }); // eslint-disable-line react/no-set-state
  }

  onQuantityChange(quantity) {
    this.setState({ quantity }); // eslint-disable-line react/no-set-state
  }

  onStateChange(state) {
    this.setState({ state }); // eslint-disable-line react/no-set-state
  }

  render() {
    var { currency, quantity, state } = this.state;
    var {
      badge,
      detailsUrl,
      disabled,
      enterError,
      entering,
      isGameBoard,
      isOpen,
      itemsPurchasedByUser,
      itemsRemaining,
      maxItemsPerUser,
      onAddToCart,
      onEnter,
      onRemoveFromCart,
      price,
      session,
      sessionShowLogin,
      successDetailsMessage
    } = this.props;
    var userTicketsLeft = maxItemsPerUser - itemsPurchasedByUser;
    var ticketsLeft = Math.min(userTicketsLeft, itemsRemaining);

    var ticketPrice = price[currency];
    if (currency === "token") {
      ticketPrice = 1;
    }

    var entryDisabled = state !== "enter-now" || ticketsLeft === 0 || !isOpen || disabled;
    var isHead2Head = maxItemsPerUser === 1;
    var currencyPicker = (
      <CurrencySelector
        currency={currency}
        disabled={entryDisabled}
        onCurrencyChange={this.onCurrencyChange}
        price={price}
        session={session} />
    );
    if (Object.keys(price).length < 2 && !isHead2Head) {
      currencyPicker = null;
    }

    var qtys = sequence(1, Math.max(2, ticketsLeft + 1)).map((n) => <QuantityWithPrice currency={currency} key={n} quantity={n} unitPrice={ticketPrice} />);
    var quantityPicker = (
      <ButtonMenu disabled={entryDisabled} onChange={(i) => this.onQuantityChange(i + 1)} selected={quantity - 1}>
        {qtys}
      </ButtonMenu>
    );
    if (isHead2Head) {
      quantityPicker = null;
    }

    var button;
    if (!isOpen) {
      button = (
        <PopStep1CannotEnter
          badge={badge}
          isGameBoard={isGameBoard}
          tournamentUrl={detailsUrl} />
      );
    } else if (entering) {
      button = <PopStep3 currency={currency} quantity={quantity} ticketPrice={ticketPrice} />;
    } else if (userTicketsLeft === 0 && state !== "confirmed") {
      button = (
        <PopStep1CannotEnter
          badge={badge}
          isGameBoard={isGameBoard}
          tournamentUrl={detailsUrl} />
      );
    } else if (itemsRemaining === 0) {
      button = (
        <PopStep1CannotEnter
          badge={badge}
          isGameBoard={isGameBoard}
          tournamentUrl={detailsUrl} />
      );
    } else if (state === "enter-now") {
      // FIXME: the constant arrow function creation is bad for perf
      var changeToConfirm = (e) => {
        e.stopPropagation();
        if (!session.get("user_id")) {
          sessionShowLogin();
        } else {
          if (onAddToCart) {
            onAddToCart(quantity, currency);
          }
          this.onStateChange("confirm");
        }
      };
      var rulesUrl;
      if (!isGameBoard) {
        rulesUrl = detailsUrl;
      }
      button = (
        <PopStep1
          currency={currency}
          disabled={entryDisabled}
          onClick={changeToConfirm}
          quantity={quantity}
          rulesUrl={rulesUrl}
          ticketPrice={ticketPrice}
          ticketsLeft={ticketsLeft} />
      );
    } else if (state === "confirm") {
      var cancel = (e) => {
        e.stopPropagation();
        if (onRemoveFromCart) {
          onRemoveFromCart(quantity, currency);
        }
        this.onStateChange("enter-now");
      };
      var changeToConfirmed = (e) => {
        e.stopPropagation();
        onEnter(quantity, currency);
        this.onStateChange("confirmed");
      };
      var depositUrl;
      if (currency === "usd" && (quantity * ticketPrice) > session.get("money_balance")) {
        depositUrl = "/deposit";
      }
      button = (
        <PopStep2
          currency={currency}
          depositUrl={depositUrl}
          onCancel={cancel}
          onClick={changeToConfirmed}
          quantity={quantity}
          ticketPrice={ticketPrice} />
      );
    } else if (state === "confirmed") {
      var reset = (e) => {
        e.stopPropagation();
        this.onStateChange("enter-now");
      };
      var makePicksUrl;
      if (!isGameBoard) {
        makePicksUrl = detailsUrl;
      }
      button = (
        <PopStep4
          error={enterError}
          makePicksUrl={makePicksUrl}
          onReset={reset}
          successDetailsMessage={successDetailsMessage}
          userTicketsLeft={userTicketsLeft} />
      );
    }

    return (
      <div className="pop">
        <div className="pop_table">
          <div className="pop_cell pop_cell--your-entries">
            <dl className="pop_item tooltip" data-tooltip={"You have " + (userTicketsLeft) + " entries remaining."}>
              <dt>
                Your Entries:
              </dt>

              <dd>
                <span className="pop_label">
                  {itemsPurchasedByUser}
                </span>

                <span className="pop_sub">
                  <span>
                    /
                  </span>

                  <span>
                    {maxItemsPerUser}
                  </span>
                </span>
              </dd>
            </dl>
          </div>

          <div className="pop_cell pop_cell--entries">
            <dl className="pop_item">
              <dt>
                Purchase Entries:
              </dt>

              <dd>
                <div className="pop_entries">
                  {currencyPicker}

                  {quantityPicker}
                </div>
              </dd>
            </dl>
          </div>

          <div className="pop_cell pop_cell--cta">
            <div>
              {button}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

var PopStep1 = pure(function PopStep1({ currency, disabled, onClick, quantity, ticketPrice, ticketsLeft, rulesUrl }) {
  var rulesLink;
  if (rulesUrl) {
    rulesLink = (
      <div>
        <Link className="btn btn--small margin-top--is-5" to={rulesUrl}>
          View Game
        </Link>
      </div>
    );
  }
  return (
    <div>
      <PopTotal currency={currency} quantity={quantity} ticketPrice={ticketPrice} />

      <NotificationButton disabled={disabled} onClick={onClick} primary={ticketsLeft}>
        {ticketsLeft ? "Enter Now" : "No Entry"}
      </NotificationButton>

      {rulesLink}
    </div>
  );
});

var PopTotal = pure(function PopTotal({ currency, quantity, ticketPrice }) {
  // if (tournament.get("real_money")) {
  //   return <PopTotalLiveBankroll currency={currency} quantity={quantity} ticketPrice={ticketPrice} tournament={tournament} />;
  // }
  return (
    <dl className="pop_total">
      <dt>
        Total Entry Fee:
      </dt>

      <dd>
        <div>
          <AutoFormattedCurrency currency={currency} value={quantity * ticketPrice} />
        </div>
      </dd>
    </dl>
  );
});

// var PopTotalLiveBankroll = pure(function PopTotalLiveBankroll({ currency, quantity, ticketPrice, tournament }) {
//   var entry = quantity * (ticketPrice - tournament.get("bankroll_buy_in_amount"));
//   var bankroll = quantity * tournament.get("bankroll_buy_in_amount");
//   var total = quantity * ticketPrice;
//   return (
//     <div>
//       <dl className="pop_total">
//         <dt>
//           Game Entry Fee:
//           &nbsp;
//           <AutoFormattedCurrency currency={currency} value={entry} />
//         </dt>
//       </dl>
//       <dl className="pop_total border-bottom--width-1">
//         <dt>
//           Live Bankroll Fee:
//           &nbsp;
//           <AutoFormattedCurrency currency={currency} value={bankroll} />
//         </dt>
//       </dl>
//       <dl className="pop_total">
//         <dt>
//           Total Purchase:
//         </dt>
//         <dd>
//           <div>
//             <AutoFormattedCurrency currency={currency} value={total} />
//           </div>
//         </dd>
//       </dl>
//     </div>
//   );
// });

var PopStep1CannotEnter = pure(function PopStep1CannotEnter({ badge, isGameBoard, message = "View Game", primary, tournamentUrl }) {
  if (badge) {
    badge = (
      <div className="margin-bottom--is-10">
        {badge}
      </div>
    );
  }
  return (
    <div>
      {badge}

      <Link
        className={classes({
          "btn": true,
          "btn--emphasis": true,
          "btn--primary": primary,
          "btn--is-disabled": isGameBoard
        })} to={tournamentUrl}>
        {isGameBoard ? "No Entry" : message}
      </Link>
    </div>
  );
});

var PopStep2 = pure(function PopStep2({ currency, depositUrl, onCancel, onClick, quantity, ticketPrice }) {
  var depositHeader = (
    <div className="text--is-bold text-small">
      Please confirm your order:
    </div>
  );
  var depositLink = (
    <button className="btn btn--primary btn--emphasis btn--small" onClick={onClick} type="button">
      Continue
    </button>
  );
  var cancelText = "Cancel";
  if (depositUrl) {
    depositHeader = (
      <div className="text--is-bold color--is-error">
        <i className="dw-warning7 dw--1-25x" />

        {" "}
        Insufficient funds.
      </div>
    );
    depositLink = (
      <Link className="btn btn--primary btn--emphasis btn--small" to={depositUrl}>
        Deposit
      </Link>
    );
    cancelText = "Edit Order";
  }
  return (
    <div>
      {depositHeader}

      <dl className="pop_total pop_total--large">
        <dt>
          <i className="dw-ticket-solid dw--1-25x color--is-copen-blue" />

          {" "}

          {quantity}

          {" "}

          {quantity === 1 ? "Ticket" : "Tickets"}
          :
        </dt>

        <dd>
          <div>
            <AutoFormattedCurrency currency={currency} value={quantity * ticketPrice} />
          </div>
        </dd>
      </dl>

      <button className="btn btn--small btn--clean" onClick={onCancel} type="button">
        {cancelText}
      </button>

      {depositLink}
    </div>
  );
});

var PopStep3 = pure(function PopStep3({ currency, quantity, ticketPrice }) {
  return (
    <div>
      <div className="text--is-bold text-small">
        Checking ticket availability...
      </div>

      <dl className="pop_total pop_total--large">
        <dt>
          <i className="dw-ticket-solid dw--1-25x color--is-copen-blue" />

          {" "}

          {quantity}

          {" "}

          {quantity === 1 ? "Ticket" : "Tickets"}
          :
        </dt>

        <dd>
          <div>
            <AutoFormattedCurrency currency={currency} value={quantity * ticketPrice} />
          </div>
        </dd>
      </dl>

      <button className="btn btn--is-disabled btn--is-loading btn--emphasis" onClick={(e) => e.stopPropagation()} type="button">
        Processing...
      </button>
    </div>
  );
});

var PopStep4 = pure(function PopStep4({ error, onReset, makePicksUrl, successDetailsMessage, userTicketsLeft }) {
  var errorMessage = (
    <div className="text--is-bold color--is-lime margin-bottom--is-10">
      <i className="dw-checkmark3 dw--1-25x" />

      {" "}
      Success! Good luck!
    </div>
  );
  if (error) {
    errorMessage = (
      <div className="text--is-bold color--is-red margin-bottom--is-5">
        <i className="dw-warning7 dw--1-25x" />

        {" "}

        {error}
      </div>
    );
  }

  var makePicksLink = (
    <div className="text-small line-height--is-small color--is-lime">
      {successDetailsMessage}
    </div>
  );
  if (makePicksUrl) {
    makePicksLink = (
      <Link className="btn btn--primary btn--emphasis" to={makePicksUrl}>
        {successDetailsMessage}
      </Link>
    );
  }
  if (error) {
    if (makePicksUrl) {
      makePicksLink = (
        <Link className="btn btn--emphasis" to={makePicksUrl}>
          View Game
        </Link>
      );
    } else {
      makePicksLink = null;
    }
  }

  var maxEntries;
  var buyMore = (
    <ButtonLink className="text-small display--is-block margin-top--is-5" onClick={onReset}>
      Buy More Tickets
    </ButtonLink>
  );
  if (userTicketsLeft === 0) {
    maxEntries = null;
    buyMore = null;
  }

  return (
    <div>
      {errorMessage}

      {maxEntries}

      {makePicksLink}

      {buyMore}
    </div>
  );
});

var QuantityWithPrice = pure(function QuantityWithPrice({ currency, quantity, unitPrice }) {
  return (
    <span>
      {quantity}

      <span className="btn_note_inline">
        (
        <AutoFormattedCurrency currency={currency} value={unitPrice * quantity} />
        )
      </span>
    </span>
  );
});
